/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_Save_FailedInputs */

const vi_online_price_save_failed = /** @type {(inputs: Online_Price_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu giá Online thất bại`)
};

/**

* @param {Online_Price_Save_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_save_failed = /** @type {((inputs?: Online_Price_Save_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Save_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_save_failed(inputs)
});